import React from "react";
import LegalLayout, { Section } from "./LegalLayout";

export default function LegalNotice() {
  return (
    <LegalLayout eyebrow="Legal" title="Legal Notice" updated="February 2026">
      <p>This legal notice provides information about the entity operating the website <strong>cakeworldusa.com</strong> and the Services offered through it.</p>

      <Section n="1" title="Company information">
        <p><strong>Business name:</strong> Cake World USA<br/>
        <strong>Address:</strong> Phoenix, Arizona, United States<br/>
        <strong>Contact email:</strong> <a href="mailto:info@cakeworldusa.com" className="text-brand-red">info@cakeworldusa.com</a><br/>
        <strong>Phone:</strong> +1 (623) 324-7530</p>
      </Section>

      <Section n="2" title="Scope of activity">
        <p>Cake World USA is a business-to-business (B2B) wholesale supplier of premium desserts to hospitality businesses across the United States. We do not operate a consumer-facing retail store or sell to individuals for personal use.</p>
      </Section>

      <Section n="3" title="Intellectual property">
        <p>The Cake World brand, logo, product names, photographs, recipes, illustrations and all content published on this website are the exclusive property of Cake World USA and are protected under U.S. and international intellectual property laws. Any reproduction, distribution or commercial use — total or partial — is prohibited without prior written authorization.</p>
      </Section>

      <Section n="4" title="Hosting and technology">
        <p>This website is hosted on cloud infrastructure located in the United States. Email notifications are delivered through Resend. Application data is stored in secure managed databases.</p>
      </Section>

      <Section n="5" title="Responsibility">
        <p>While we strive to keep the information published on this website accurate and up to date, Cake World USA makes no warranty as to the completeness or accuracy of the information. Product photography is illustrative — final presentation may vary slightly based on batch, season and packaging.</p>
      </Section>

      <Section n="6" title="Reporting an issue">
        <p>If you find any content on this website that infringes your rights or applicable regulations, please contact us at <a href="mailto:info@cakeworldusa.com" className="text-brand-red">info@cakeworldusa.com</a> and we will review the matter promptly.</p>
      </Section>
    </LegalLayout>
  );
}
